import "./index.scss";

import { Modal, Stack } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import Button from "components/Button";
import SearchableList from "components/SearchableList";
import {
  GENERIC_MEMBER_STATUS_OPTIONS,
  MSG_OPERATION_FAILED,
  MSG_OPERATION_SUCCESSFUL,
} from "constants/index";
import { massStatusUpdate } from "modules/member/memberServices";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const MassStatusUpdateModal = (props: { open: boolean; onClose: any; memberIds: number[] }) => {
  const { open, onClose, memberIds } = props;
  const [isPending, setIsPending] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string>();

  useEffect(() => {
    if (open) {
      setSelectedStatus("");
    }
  }, [open]);

  //#region event handlers
  const handleCloseModal = (isRefreshNeeded = false) => {
    if (isPending) return;
    onClose(isRefreshNeeded);
  };

  const handleConfirm = () => {
    if (!selectedStatus) {
      toast("Select a status", { type: "error" });
      return;
    }
    setIsPending(true);
    massStatusUpdate({
      members: memberIds,
      status: selectedStatus,
    })
      .then((res) => {
        if (res.success) {
          toast(MSG_OPERATION_SUCCESSFUL, { type: "success" });
          handleCloseModal(true);
        }
      })
      .catch((e) => {
        console.log(e);
        toast(MSG_OPERATION_FAILED, { type: "error" });
      })
      .finally(() => setIsPending(false));
  };
  //#endregion event handlers

  return (
    <Modal
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      open={open}
      onClose={() => handleCloseModal(false)}
    >
      <Stack className="personal-details-modal-container mass-status-switch-container">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="40px"
          className="header"
        >
          <h1>Status Switch ({memberIds.length} Members) </h1>
          <DeleteIcon width="24px" height="24px" onClick={() => handleCloseModal(false)} />
        </Stack>
        <SearchableList
          className="base-list"
          options={GENERIC_MEMBER_STATUS_OPTIONS.filter((f) => !f.isSelectAll)}
          isMultiple={false}
          callback={(v) => setSelectedStatus(v[0])}
        />
        <Stack direction="row" alignItems="center" justifyContent="flex-end" marginTop="30px">
          <Stack direction="row" alignItems="center" spacing={3}>
            <Button
              type="button"
              label="Cancel"
              className="text-button"
              onClick={() => handleCloseModal(false)}
            />
            <Button
              type="button"
              label="Reassign"
              className="confirm-button"
              loading={isPending}
              onClick={handleConfirm}
            />
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default MassStatusUpdateModal;
